import Vue from 'vue'
import Vuex from 'vuex'
import axios from '@/plugins/axios'
// import system from './modules/system'
import notification from './modules/notification'
import prompt from './modules/prompt'
import error from './modules/error'
import countries from './modules/countries'
import user from './modules/user'
import radars from './modules/radars'
import blobs from "./modules/blobs";
import tags from "./modules/tags";
import linking from "./modules/linking";

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  modules: {
    // system,
    notification,
    prompt,
    countries,
    error,
    user,
    radars,
    blobs,
    tags,
    linking
  },
  state: {
    loadingQueue: []
  },
  getters: {
    /**
     * is app loading - is loading queue empty
     * @param state
     * @returns {boolean}
     */
    isLoading: (state) => {
      return state.loadingQueue.length > 0
    },
  },
  actions: {
    /**
     * init app
     * @param state
     * @param commit
     * @param dispatch
     * @returns {Promise<unknown[]>}
     */
    initApp({state, commit, dispatch}) {
      commit('addToLoadingQueue', 'app');

      axios.defaults.headers.common = {
        'Authorization': 'Bearer ' + state.user.token,
        // 'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
        'X-Requested-With': 'XMLHttpRequest'
      };

      return new Promise((resolve, reject) => {
        dispatch('user/userInfo')
          .then((response) => {
            Promise.all([
              dispatch('radars/loadRadars'),
              dispatch('countries/loadCountries')
            ])
              .then((response) => {
                commit('removeFromLoadingQueue', 'app')
                resolve(response);
              })
              .catch((error) => {
                commit('removeFromLoadingQueue', 'app')

                commit('error/newError', {
                  title: 'error.system.load',
                  text: error.response? error.response.data.message || error.message: error.message
                }, { root: true});

                reject(error)
              });

            resolve(response)
          })
          .catch((error) => {
            commit('removeFromLoadingQueue', 'app')
            reject(error)
          })
      });
    },
  },
  mutations: {
    /**
     * add module to loading queue
     * @param state
     * @param module
     */
    addToLoadingQueue(state, module) {
      if(state.loadingQueue.indexOf(module) <= -1)
        state.loadingQueue.push(module)
    },

    /**
     * remove module from loading queue
     * @param state
     * @param module
     */
    removeFromLoadingQueue(state, module) {
      let pos = state.loadingQueue.indexOf(module);

      if(pos > -1)
        state.loadingQueue.splice(pos, 1)
    },

    flushLoadingQueue(state) {
      state.loadingQueue = []
    }
  },
  strict: debug
})
